// Text Accordion Component Class
class TextAccordion {
    constructor(container) {
    this.container = container;
    this.accordionContainer = container.querySelector('.text-accordion-container');
    this.textAccordionItems = this.accordionContainer.querySelectorAll('.info-list .item');
    this.images = this.accordionContainer.querySelectorAll('.img-container .image');
    this.init();
    }

    init() {
    this.bindEvents();
    }

    bindEvents() {
    this.textAccordionItems.forEach((item, index) => {
        item.addEventListener('click', () => this.handleItemClick(item, index));
    });
    }

    handleItemClick(item, index) {
    const isActive = item.classList.contains('active');

    if (!isActive) {
        // 移除当前容器内所有item的active类
        this.textAccordionItems.forEach(i => i.classList.remove('active'));
        // 给当前item添加active类
        item.classList.add('active');
        // 切换对应的图片
        this.switchImage(index);
    }
    // 如果点击的是已经active的item，不做任何操作（保持至少一个active状态）
    }

    // 图片切换函数
    switchImage(activeIndex) {
    this.images.forEach((img, index) => {
        img.classList.toggle('active', index === activeIndex);
    });
    }
}

// 初始化所有 Text Accordion 实例
document.addEventListener('DOMContentLoaded', function () {
    const textAccordionBoxes = document.querySelectorAll('.text-accordion-component-box');
    textAccordionBoxes.forEach(box => new TextAccordion(box));
});